import { Box, Image, Text } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import React, { FC } from 'react';

import { TLocalesKeys as K } from '../../../../types';
import { removeProtocol } from '../../../../util';
import { hasContent } from '../../../../util/guards';
import { ISiteItem } from '../../../common/messageCreators';

export const SiteItem: FC<ISiteItem> = ({ _id, url, thumbnail, name, premium }) => {
  const { t } = useTranslation();

  const subtitle = hasContent(url) ? removeProtocol(url) : t<K>('site_not_published');

  return (
    <Box gap="SP3" verticalAlign="middle" dataHook={`site-${_id}`}>
      <Box flexShrink={0}>
        <Image
          fit="cover"
          width="60px"
          height="36px"
          src={thumbnail ? `${thumbnail}?preset=site-details` : undefined}
          dataHook="thumbnail"
          borderRadius={0}
          showBorder
        />
      </Box>
      <Box overflow="hidden" maxWidth="100%" direction="vertical" gap="SP1">
        <Box direction="vertical">
          <Text dataHook="site-name" ellipsis>
            {name}
          </Text>
          <Text secondary light dataHook="subtitle" size="tiny" overflow="hidden" ellipsis>
            {subtitle}
          </Text>
        </Box>
        <Box whiteSpace="pre-wrap">
          <Text secondary dataHook="plan-prefix" size="tiny">
            {t<K>('site_plan_prefix')}
          </Text>
          <span> </span>
          <Text dataHook="plan-name" size="tiny" skin={premium ? 'premium' : undefined} secondary={!premium}>
            {premium ? t<K>('site_plan') : t<K>('site_plan_none')}
          </Text>
        </Box>
      </Box>
    </Box>
  );
};
